import ApplicationAdapter from 'cio/adapters/application';
import { ModelRegistry } from 'ember-data/model';
import DS from 'ember-data';

export default class SigningSecretAdapter extends ApplicationAdapter {
  buildURL(
    _modelName?: keyof ModelRegistry,
    _id?: string,
    _snapshot?: DS.Snapshot | any[] | null,
    _requestType?: string,
    _query?: Record<string, number | string>,
  ): string {
    return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/signing_secret`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'signing-secret': SigningSecretAdapter;
  }
}
